
import Kaia2 from '../kaia/Kaia (1).webp'
import Kaia3 from '../kaia/Kaia (2).webp'
import Kaia4 from '../kaia/Kaia (3).webp'
import Kaia5 from '../kaia/Kaia (4).webp'
import Kaia6 from '../kaia/Kaia (5).webp'
import Kaia7 from '../kaia/Kaia (6).webp'
import Kaia8 from '../kaia/Kaia (7).webp'
import Kaia9 from '../kaia/Kaia (8).webp'
import Kaia10 from '../kaia/Kaia (9).webp'
import Kaia11 from '../kaia/Kaia (10).webp'
import Kaia12 from '../kaia/Kaia (11).webp'


const Kaiaimages =[
    Kaia2,Kaia3,Kaia4,Kaia5,Kaia6,Kaia7,Kaia8,Kaia9,Kaia10,Kaia11,Kaia12
]

export default Kaiaimages;